<template>
  <footer class="footer">
    <a href="mailto:contact@adoratorio.com">© 2019</a>
    <div class="links">
      <a target="_blank" href="https://www.iubenda.com/privacy-policy/728169" rel="noopener">
        Privacy
      </a> ⏤ <a rel="noopener" target="_blank" href="https://www.iubenda.com/privacy-policy/728169/cookie-policy">
        Cookies
      </a>
    </div>
    <div class="smile" @click="scrollTop">
      <img src="/static/vector/smile.svg" alt="Smile" />
      <span>Take a stand</span>
    </div>
  </footer>
</template>

<script>
import hades from '@/scripts/hades';

export default {
  name: 'FooterSection',

  methods: {
    scrollTop() {
      hades.ref.scrollTo({ x: 0, y: 0 }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 100px;
  font-size: rem(40px);

  @include mq($until: ipadL) {
    font-size: rem(24px);

    > div {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0px;
      }
    }
  }

  @include mq($until: ipadP) {
    flex-direction: column;
    font-size: rem(24px);
    padding: 0px 20px;
  }

  .links {
    a {
      cursor: pointer;
      position: relative;
      display: inline-block;

      &::after {
        content: " ";
        position: absolute;
        bottom: 3px;
        left: 0px;
        width: 100%;
        height: 1px;
        background-color: $color-white;
        transform: scaleX(0);
        transform-origin: 0px 50%;
        transition: transform .6s cubic-bezier(.9, .25, .1, .75);
      }

      &:hover::after {
        transform: scaleX(1);
      }
    }
  }

  .smile {
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      margin-right: 50px;

      @include mq($until: ipadL) {
        width: 30px;
        height: 30px;
      }

      @include mq($until: ipadP) {
        width: 18px;
        height: 18px;
        margin-right: 20px;
      }
    }
  }
}
</style>
